import axios from 'axios'

const TIMEOUT = 15000

const sendContinueMail = async (transactionId: string, contactData: any) => {
  const sendContinueMailUrl = `${process.env.REACT_APP_CONTINUE_LATER_MAIL}`
  return axios.post(
    sendContinueMailUrl,
    {
      transactionId,
      timezoneOffset: new Date().getTimezoneOffset(),
      contactData,
    },
    {
      validateStatus: (status) => status === 200,
      timeout: TIMEOUT,
    }
  )
}

export { sendContinueMail }
